/**
 * Bio Gallery - Navigation and Drag-to-Scroll
 * Implements smooth navigation and drag-to-scroll functionality for the bio gallery
 */
document.addEventListener('DOMContentLoaded', function() {
    // Simple gallery navigation with scroll distance control
    
    // Set up a function to initialize the gallery when elements are available
    let galleryInitialized = false;
    let maxAttempts = 20; // Increased for better reliability
    let attempts = 0;
    
    // Try to initialize the gallery
    function initGallery() {
        // Gallery elements
        const galleryContainer = document.getElementById('bio-gallery-images');
        const prevButton = document.getElementById('gallery-prev');
        const nextButton = document.getElementById('gallery-next');
        const sendToChatButtons = document.querySelectorAll('.send-to-chat');
        
        // If elements aren't found yet, try again later (up to maxAttempts)
        if (!galleryContainer && attempts < maxAttempts) {
            console.log(`Gallery container not found yet. Attempt ${attempts + 1}/${maxAttempts}`);
            attempts++;
            // Increasing the delay to give more time for the DOM to update
            setTimeout(initGallery, 300);
            return;
        } else if (!galleryContainer) {
            console.error("Gallery container could not be found after multiple attempts.");
            return;
        }
        
        // Prevent duplicate initialization
        if (galleryInitialized) {
            return;
        }
        
        // Check if there are images in the gallery
        const imageCount = galleryContainer.querySelectorAll('.bio-gallery-image-wrapper').length;
        console.log(`Bio Gallery found ${imageCount} images`);
        
        galleryInitialized = true;
        console.log("Bio Gallery found and initialized");
        
        // Gallery configuration
        const imageWidth = 250; // Width of each image wrapper
        const imageGap = 15;    // Gap between images
        const scrollAmount = imageWidth + imageGap;
        
        // Initialize navigation buttons
        if (prevButton) {
            prevButton.addEventListener('click', function() {
                // Scroll left by one image width + gap
                galleryContainer.scrollBy({
                    left: -scrollAmount,
                    behavior: 'smooth'
                });
            });
        }
        
        if (nextButton) {
            nextButton.addEventListener('click', function() {
                // Scroll right by one image width + gap
                galleryContainer.scrollBy({
                    left: scrollAmount,
                    behavior: 'smooth'
                });
            });
        }
        
        // Variables for drag scrolling
        let isDragging = false;
        let startX;
        let scrollLeft;
        
        // Implement drag-to-scroll functionality
        galleryContainer.addEventListener('mousedown', function(e) {
            isDragging = true;
            galleryContainer.classList.add('dragging');
            startX = e.pageX - galleryContainer.offsetLeft;
            scrollLeft = galleryContainer.scrollLeft;
            
            // Prevent default behavior to avoid text selection during drag
            e.preventDefault();
        });
        
        galleryContainer.addEventListener('mouseleave', function() {
            isDragging = false;
            galleryContainer.classList.remove('dragging');
        });
        
        galleryContainer.addEventListener('mouseup', function() {
            isDragging = false;
            galleryContainer.classList.remove('dragging');
        });
        
        galleryContainer.addEventListener('mousemove', function(e) {
            if (!isDragging) return;
            
            const x = e.pageX - galleryContainer.offsetLeft;
            const walk = (x - startX) * 1.5; // Scroll speed multiplier
            galleryContainer.scrollLeft = scrollLeft - walk;
        });
        
        // Touch support for mobile devices
        galleryContainer.addEventListener('touchstart', function(e) {
            isDragging = true;
            galleryContainer.classList.add('dragging');
            startX = e.touches[0].pageX - galleryContainer.offsetLeft;
            scrollLeft = galleryContainer.scrollLeft;
        });
        
        galleryContainer.addEventListener('touchend', function() {
            isDragging = false;
            galleryContainer.classList.remove('dragging');
        });
        
        galleryContainer.addEventListener('touchmove', function(e) {
            if (!isDragging) return;
            
            const x = e.touches[0].pageX - galleryContainer.offsetLeft;
            const walk = (x - startX) * 1.5;
            galleryContainer.scrollLeft = scrollLeft - walk;
            
            // Prevent page scrolling while dragging the gallery
            e.preventDefault();
        });
        
        // Send to Chat button functionality
        if (sendToChatButtons && sendToChatButtons.length > 0) {
            sendToChatButtons.forEach(button => {
                button.addEventListener('click', function() {
                    // Get the current selected image information
                    const activeIndex = Math.round(galleryContainer.scrollLeft / scrollAmount);
                    const imageWrappers = galleryContainer.querySelectorAll('.bio-gallery-image-wrapper');
    
                    if (activeIndex >= 0 && activeIndex < imageWrappers.length) {
                        const selectedImage = imageWrappers[activeIndex].querySelector('img');
                        const imageDescription = selectedImage.alt;
    
                        // Get text content from the bio section that contains the image
                        const bioSection = document.querySelector('.bio-section-content');
                        let bioText = '';
    
                        if (bioSection) {
                            const paragraphs = bioSection.querySelectorAll('p');
                            if (paragraphs.length > 0) {
                                bioText = paragraphs[0].textContent;
                            }
                        }
    
                        // Combine image description and bio text
                        const textToSend = imageDescription + ': ' + bioText;
                        
                        console.log('Send to Chat button clicked with text:', textToSend);
                        
                        // Use the BioController's handleSendToChat method if available
                        // This provides direct control over camera reset
                        if (window.bioController && typeof window.bioController.handleSendToChat === 'function') {
                            console.log('Using BioController.handleSendToChat() for proper camera reset');
                            window.bioController.handleSendToChat(textToSend);
                        } else {
                            console.warn('BioController not available, using fallback method');
                            
                            // Fallback to manual panel closing (only if BioController is not available)
                            const bioPanel = document.getElementById('bio-panel');
                            const bioButton = document.getElementById('bio-button');
    
                            if (bioPanel) {
                                // Remove active class from bio button
                                if (bioButton) {
                                    bioButton.classList.remove('bio-button-active');
                                }
    
                                // Add smooth sliding animation when closing
                                bioPanel.style.transition = 'transform 0.9s cubic-bezier(0.23, 1, 0.32, 1), opacity 0.7s ease, width 0.5s ease';
                                bioPanel.style.transform = 'translateX(110%)';
                                bioPanel.style.opacity = '0.2';
    
                                setTimeout(() => {
                                    bioPanel.classList.remove('active');
                                    bioPanel.style.transform = 'translateX(100%)';
                                    bioPanel.style.opacity = '0';
                                    setTimeout(() => bioPanel.style.transition = '', 200);
                                    
                                    // Try to reset camera position as best we can
                                    if (window.modelViewer) {
                                        const camera = window.modelViewer.camera;
                                        const controls = window.modelViewer.controls;
                                        
                                        if (camera && controls) {
                                            camera.position.set(0, 180, 300);
                                            controls.target.set(0, 160, 0);
                                            camera.lookAt(controls.target);
                                            controls.update();
                                        }
                                    }
                                }, 950);
                            }
                            
                            // Show the chat container
                            const chatContainer = document.querySelector('.chat-container');
                            if (chatContainer) {
                                chatContainer.classList.add('visible');
                            }
                            
                            console.log('Sending to chat directly:', textToSend);
                            
                            // Find the chatController to send the message directly
                            if (window.chatController) {
                                // Use the ChatController to send the message directly
                                window.chatController.sendMessage(textToSend);
                            } else {
                                // Fallback to the old method if ChatController is not available
                                const chatInput = document.getElementById('chat-input');
                                if (chatInput) {
                                    // Set the text and focus
                                    chatInput.value = textToSend;
                                    chatInput.focus();
                                    
                                    // Trigger input event for height adjustment
                                    const inputEvent = new Event('input', { bubbles: true });
                                    chatInput.dispatchEvent(inputEvent);
                                    
                                    // Trigger a focus event to ensure any event listeners for chat UI are triggered
                                    const focusEvent = new Event('focus', { bubbles: true });
                                    chatInput.dispatchEvent(focusEvent);
                                    
                                    // Simulate clicking the send button
                                    const sendButton = document.getElementById('send-button');
                                    if (sendButton) {
                                        sendButton.click();
                                    }
                                }
                            }
                        }
    
                        console.log('Sending to chat:', textToSend);
                    }
                });
            });
        }
    }
    
    // Start the gallery initialization process
    initGallery();
    
    // Also try to initialize when the bio panel is opened (it might not be in DOM initially)
    document.addEventListener('click', function(e) {
        if (e.target && e.target.id === 'bio-button') {
            // Wait a bit for the bio panel to be added to DOM
            setTimeout(initGallery, 500);
        }
    });
});